import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import InflowsMoneyFlowSectionLayout from './InflowsMoneyFlowsSectionLayout';
import { InflowsMoneyFlows } from './InflowsMoneyFlows/InflowsMoneyFlows';

const metaOverrides = buildFacetDesignOverride().nameOverride('moneyFlows', {
  _component: () => InflowsMoneyFlows,
}, overrideReadOnly);

const InflowsMoneyFlowSection = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={InflowsMoneyFlowSectionLayout}
      resource={resource}
      metaOverrideSet={metaOverrides}
    />
  );
};

InflowsMoneyFlowSection.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
InflowsMoneyFlowSection.defaultProps = {};

export default InflowsMoneyFlowSection;
